module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBold.7d73bb09.ttf";